import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

import { OthersAction } from "../../store/actions";

import { Spacer, inputFields, university, Buttons } from "../../components";

const AddCountry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { continents, regions } = useSelector((state) => state?.others);

  const [state, setState] = useState({
    name: "",
    countryCode: "",
    continentID: null,
    regionsID: null,
  });

  const handleSubmit = () => {
    if (!state.name || !state.continentID) {
      message.error("Please fill all the required fields");
      return;
    } else {
      const payload = state;

      dispatch(
        OthersAction.addCountry(payload, (res) => {
          dispatch(OthersAction.getCountries());
          if (res.status === 200) {
            navigate("/country");
          }
        })
      );
    }
  };

  return (
    <div className="text-black">
      <div className="grid grid-cols-2 gap-5">
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Name" required />
          <inputFields.DefaultInput
            onChange={(e) => setState({ ...state, name: e.target.value })}
            value={state?.name}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Country Code" />
          <inputFields.DefaultInput
            onChange={(e) =>
              setState({ ...state, countryCode: e.target.value })
            }
            value={state?.countryCode}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Continent" required />
          <inputFields.SelectDropdown
            items={continents?.map((continent) => ({
              label: continent.name,
              value: continent.id,
            }))}
            onChange={(e) => setState({ ...state, continentID: e })}
            value={state?.continentID}
          />
        </div>
        <div className="flex flex-col gap-3">
          <university.UniInputLabel title="Region" />
          <inputFields.SelectDropdown
            items={regions?.map((region) => ({
              label: region.name,
              value: region.id,
            }))}
            onChange={(e) => setState({ ...state, regionsID: e })}
            value={state?.regionsID}
          />
        </div>
      </div>
      <Spacer height={20} />
      <div className="flex w-full justify-end">
        <Buttons.DefaultButton onClick={handleSubmit}>
          Submit
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default AddCountry;
